const DEFAULT_MESSAGE = 'La tarjeta fue declinada por el banco.';
const AuthErrorMessages = {
    'branch_code_not_found': 'Código incorrecto.',
};
const parseAuthError = (error) => AuthErrorMessages[error] || DEFAULT_MESSAGE;
export default parseAuthError;
